import React, { useRef } from "react";
import Slider from "react-slick";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import nakul from '../../assets/testimonial/Nukul.jpeg';
import priyanka from '../../assets/testimonial/priyanka.jpeg';
import gaurav from '../../assets/testimonial/Gaurav.jpeg';
import shanuj from '../../assets/testimonial/shanuj.jpeg';
import ayushi from '../../assets/testimonial/ayushi.jpeg';
import { Helmet } from "react-helmet";

const Testimonials = () => {
    const sliderRef = useRef(null);

    const testimonials = [
        { id: 0, name: "Gaurav", place: "Jaipur", trip: "Jaipur to Udaipur Trip", desc: "The Best Cab made my trip to Udaipur smooth and hassle-free. The car was clean, the driver was professional, and the sightseeing itinerary was perfectly planned. Highly recommend their services!", image: gaurav },
        { id: 1, name: "Nukul", place: "Jaipur", trip: "Delhi City Tour", desc: "I had an amazing experience exploring Delhi with The Best Cab. The guide was knowledgeable, and the private car was extremely comfortable. Booking was easy, and the pricing was transparent. Will book again!", image: nakul },
        { id: 2, name: "Ayushi", place: "Noida", trip: "Agra & Fatehpur Sikri Tour", desc: "Visiting the Taj Mahal was a dream come true, and The Best Cab made it even better! From hotel stay to sightseeing, everything was well organized. The driver was punctual and friendly. Great service!", image: ayushi },
        { id: 3, name: "Shanuj", place: "Gurugram", trip: "Mumbai Travel Package", desc: "I booked a Mumbai tour package with them, and it was fantastic! The itinerary covered all major attractions, and the driver was very cooperative. Loved the Bollywood Studio tour add-on. Worth every penny!", image: shanuj },
        { id: 4, name: "Priyanka", place: "Delhi", trip: "Rajasthan Road Trip", desc: "The Best Cab provided an excellent taxi service for our Rajasthan road trip. The car was well-maintained, and the driver was experienced and polite. The tour customization option was a big plus. Highly recommended!", image: priyanka },
    ];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: null,
        nextArrow: null,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 },
            },
        ],
    };

    return (
        <>
            <Helmet>
                <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
                <meta
                    name="description"
                    content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
                />
                <meta
                    name="keywords"
                    content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
                />
                <meta name="author" content="The Best Cab Jaipur" />
            </Helmet>
            <section className="bg-gradient-to-b from-gray-100 to-gray-200 py-20 mt-10 mb-10">
                <div className="min-w-screen flex flex-col items-center justify-center px-5">
                    <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6 text-center">
                        What Our Clients Say
                    </h2>

                    {/* Slick Slider */}
                    <div className="relative w-full max-w-6xl">
                        <Slider ref={sliderRef} {...sliderSettings} className="relative">
                            {testimonials.map((data) => (
                                <div key={data.id} className="px-2 sm:px-4">
                                    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 text-gray-800 flex flex-col h-[200px] sm:h-[230px] transition-all duration-300 hover:shadow-2xl hover:scale-105">
                                        <div className="w-full flex items-center mb-3 sm:mb-4">
                                            <div className="rounded-full w-12 sm:w-14 h-12 sm:h-14 flex justify-center items-center bg-pink-200 overflow-hidden border-2 border-pink-500">
                                                <img
                                                    src={data.image}
                                                    alt={data.name}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                            <div className="pl-3 sm:pl-4">
                                                <h6 className="font-bold text-md sm:text-lg">{data.name}</h6>
                                                <p className="text-xs sm:text-sm text-gray-500">{data.place}</p>
                                            </div>
                                        </div>
                                        <p className="text-sm sm:text-md text-gray-700 italic">"{data.desc}"</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>

                        {/* Custom Navigation Arrows */}
                        <button
                            className="absolute left-[-19px] sm:left-[-40px] top-1/2 transform -translate-y-1/2 bg-black text-white p-3 rounded-full shadow-lg hover:scale-110 transition z-10"
                            onClick={() => sliderRef.current.slickPrev()}
                        >
                            <MdArrowBackIos size={20} />
                        </button>
                        <button
                            className="absolute right-[-19px] sm:right-[-40px] top-1/2 transform -translate-y-1/2 bg-black text-white p-3 rounded-full shadow-lg hover:scale-110 transition z-10"
                            onClick={() => sliderRef.current.slickNext()}
                        >
                            <MdArrowForwardIos size={20} />
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Testimonials;